<template>
  <div class="mySwiper">
    <div
      class="swiper-container"
      :class="swipeid"
      :style="paginationFlag ? '' : 'padding-bottom:0px !important'"
    >
      <div
        class="swiper-wrapper"
        style="transform: translate3d(0px, 0px, 0px); transition-duration: 0ms"
        :class="type == 'home' ? 'swiper-goods-home' : ''"
      >
        <!-- 存放具体的轮播内容 -->
        <slot name="swiper-con"></slot>
      </div>
      <!-- 分页器 -->
      <div class="pagination" v-show="paginationFlag"></div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import '../../../assets/less/harvard.less';
.mySwiper {
  width: 100%;
  .banner_recommend_swiper {
    // padding-bottom: 20px;
    height: 116px;
    .swiper-wrapper {
      .swiper-slide {
        height: 116px;
        background-size: 100% 100%;
        background-position: center center;
        a {
          width: 100%;
          height: 161px;
          display: inline-block;
        }
      }
    }
    /deep/ .swiper-pagination-clickable {
      // bottom: 8px;
      font-size: 0;
      position: relative;
      text-align: center;
      transition: opacity 0.3s;
      transform: translateZ(0);
      z-index: 10;
      .swiper-pagination-bullet {
        width: 4px;
        height: 4px;
        background: @expertFontColor153;
        opacity: 1;
        margin: 0 2px;
        &.swiper-pagination-bullet-active {
          width: 12px;
          height: 4px;
          background: @mainColor;
          border-radius: 2px;
        }
      }
    }
  }

  .expert_recommend_swiper {
    padding-bottom: 20px;
    height: 173px;
    .swiper-wrapper {
      .swiper-slide {
        width: 332px;
        height: 173px;
        border-radius: 10px;
        background: url('../../../assets/images/activity/harvard/bg2.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;
        .expertHead {
          margin: 26px 30px 0;
          border-bottom: 1px solid #d7ab3a;
          padding-bottom: 10px;
          .expertImg {
            width: 52px;
            height: 52px;
            background-size: cover;
            background-position: center center;
            border-radius: 50%;
            overflow: hidden;
            float: left;
            margin-right: 15px;
          }
          .name {
            color: @colorY1;
            font-size: @fontSize16;
            font-weight: bold;
            padding: 5px 0;
            line-height: 1.2;
          }
          .hospital {
            font-size: @fontSize14;
            color: @colorY1;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        .info {
          padding: 8px 30px 0;
          color: @color153;
          font-size: @fontSize12;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
    /deep/ .swiper-pagination-clickable {
      bottom: 12px;
      font-size: 0;
      position: absolute;
      text-align: center;
      transition: opacity 0.3s;
      transform: translateZ(0);
      z-index: 10;
      .swiper-pagination-bullet {
        width: 6px;
        height: 6px;
        background: #d8d8d8;
        opacity: 1;
        margin: 0 3px;
        &.swiper-pagination-bullet-active {
          width: 6px;
          height: 6px;
          background: rgba(238, 186, 97, 1);
        }
      }
    }
  }
  .bj_doctor_swiper {
    padding-bottom: 20px;
    height: 102px;
    .swiper-wrapper {
      margin-left: -25px;
      .swiper-slide {
        position: relative;
        width: 295px;
        height: 102px;
        // background: red;
        overflow: hidden;
        box-sizing: border-box;
        border-radius: 8px;
        > div:nth-of-type(1) {
          width: 85px;
          height: 102px;
          position: relative;
          .doctor_image {
            left: 50%;
            top: 50%;
            bottom: 0;
            transform: translate(-50%, -50%);
            height: 96px;
            position: absolute;
            z-index: 100;
          }
        }

        .swiper-content {
          width: 100%;
          position: absolute;
          height: 102px;
          background: #ffffff;
          bottom: 0;
          border-radius: 10px;
          > .swiper-content-right {
            padding-top: 10px;
            box-sizing: border-box;
            float: right;
            width: 210px;
            height: 100%;
            // background: red;
            > div {
              float: left;
              > span {
                display: inline-block;
                margin-top: 10px;
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #e0b76b;
                line-height: 14px;
              }
            }

            > span:nth-of-type(1) {
              float: left;
              // display: inline-block;
              margin-top: 4px;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #e0b76b;
              line-height: 22px;
            }
            > p:nth-of-type(1) {
              margin-top: 5px;
              float: left;
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 14px;
              padding-right: 2px;
            }
          }
        }

        .info {
          padding: 8px 30px 0;
          color: @color153;
          font-size: @fontSize12;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .advertising_swiper {
    height: 34px;
    .swiper-wrapper {
      height: 34px;
      .swiper-slide {
        width: 100%;
        display: flex;
        align-items: center;
        height: 34px;
        position: relative;
        overflow: hidden;
        box-sizing: border-box;
        border-radius: 8px;
        .tagWrap {
          width: 100%;
          height: 34px;
          position: absolute;
          right: 0;
          z-index: 99;
        }
        .type {
          width: 23px;
          height: 12px;
          margin-right: 6px;
          background: #ffebf5;
          border-radius: 4px;
          border: 1px solid #fc6791;
          font-size: 9px;
          color: #f13e70;
          line-height: 13px;
          text-align: center;
        }
        p {
          width: 100%;
          font-size: 12px;
          color: #666666;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .food_column_swiper {
    position: relative;
    height: 202px;
    .swiper-wrapper {
      position: relative;
      // margin-left: -25px;
      .swiper-slide {
        position: relative;
        height: 202px;
        overflow: hidden;
        box-sizing: border-box;
        background-size: 100% 100%;
        .bottom-title {
          box-sizing: border-box;
          padding: 0 16px;
          position: absolute;
          bottom: 0px;
          width: 100%;
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          background: rgba(0, 0, 0, 0.5);
          color: #ffffff;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
    /deep/ .swiper-pagination-clickable {
      display: flex;
      justify-content: flex-end;
      margin-right: 28px;
      top: 152px;
      position: absolute;
      text-align: center;
      transition: opacity 0.3s;
      transform: translateZ(0);
      z-index: 10;
      .swiper-pagination-bullet {
        width: 6px;
        height: 6px;
        background: #c1c1c1;
        opacity: 1;
        margin: 0 6px;
        &.swiper-pagination-bullet-active {
          background: #f4c757;
        }
      }
    }
  }
  .jc_doctor_swiper {
    // .swiper-wrapper{
    //  margin-left: -20px;
    // }
    /deep/ .swiper-pagination-clickable {
      bottom: -14px;
      font-size: 0;
      position: absolute;
      text-align: center;
      transition: opacity 0.3s;
      transform: translateZ(0);
      z-index: 10;
      .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        background: #d8d8d8;
        opacity: 1;
        margin: 0 3px;
        &.swiper-pagination-bullet-active {
          width: 8px;
          height: 8px;
          background: rgba(238, 186, 97, 1);
        }
      }
    }
  }

  .topic_list_swiper {
    padding-bottom: 20px;
    height: 161px;
    .swiper-wrapper {
      .swiper-slide {
        height: 161px;
        border-radius: 8px;
        overflow: hidden;
        background-size: 100% 100%;
        background-position: center center;
        background-repeat: no-repeat;
        a {
          width: 100%;
          height: 161px;
          display: inline-block;
        }
      }
    }
    /deep/ .swiper-pagination-clickable {
      bottom: 8px;
      font-size: 0;
      position: absolute;
      text-align: center;
      transition: opacity 0.3s;
      transform: translateZ(0);
      z-index: 10;
      .swiper-pagination-bullet {
        width: 4px;
        height: 4px;
        background: @expertFontColor153;
        opacity: 1;
        margin: 0 2px;
        &.swiper-pagination-bullet-active {
          width: 12px;
          height: 4px;
          background: @mainColor;
          border-radius: 2px;
        }
      }
    }
  }
  .banner_course_swiper {
    height: 116px;
    padding-bottom: 20px;
    .swiper-wrapper {
      .swiper-slide {
        background-color: @expertBorderColor242;
        border-radius: 8px;
        overflow: hidden;
        span {
          width: 100%;
          height: 116px;
          display: block;
          background-size: cover;
          background-position: center center;
        }
      }
    }
    /deep/ .swiper-pagination-clickable {
      bottom: 8px;
      font-size: 0;
      position: relative;
      text-align: center;
      transition: opacity 0.3s;
      transform: translateZ(0);
      z-index: 10;
      .swiper-pagination-bullet {
        width: 4px;
        height: 4px;
        background: @expertFontColor153;
        opacity: 1;
        margin: 0 2px;
        &.swiper-pagination-bullet-active {
          width: 12px;
          height: 4px;
          background: @mainColor;
          border-radius: 2px;
        }
      }
    }
  }
  .xingma_goods_swiper {
    .swiper-wrapper {
      .swiper-slide {
        height: 198px;
        background: @expertFontColor255;
        box-shadow: 0px 2px 12px -2px rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        border: 1px solid @expertBorderColor242;
        box-sizing: border-box;
        a {
          width: 100%;
          display: inline-block;
        }
        .imgCon {
          height: 128px;
          background-size: cover;
          background-position: center center;
        }
        .con {
          padding: 10px 8px;
          .tit {
            font-size: @indexFontSize12;
            font-weight: bold;
            color: @expertFontColor51;
            margin-bottom: 4px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .info {
            font-size: @indexFontSize12;
            font-weight: bold;
            color: rgba(255, 109, 105, 1);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .shopline {
            color: #c1c1c1;
            text-decoration: line-through;
          }
        }
      }
    }
  }
  .detail_recommend_swiper {
    .swiper-wrapper {
      .swiper-slide {
        height: 115px;
        box-sizing: border-box;
      }
    }
  }
  .course_recommend_swiper {
    .swiper-wrapper {
      .swiper-slide {
        width: 290px !important;
        height: 121px;
        background: @expertFontColor255;
        // box-shadow:0px 3px 6px 0px rgba(112,84,0,0.31);
        border-radius: 4px;
        box-shadow: 0px 0px 2px 0px #dddddd;
        // border: 1px solid #FFFAED;
        // border: 1px solid #FFFAED;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;
        padding: 12px 11px 11px;
        .imgCon {
          width: 81px;
          height: 97px;
          background-size: cover;
          background-position: center center;
          border-radius: 4px;
          float: left;
          margin-bottom: 11px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .con {
          padding-left: 2.4rem;
          .tit {
            font-size: @indexFontSize15;
            color: @expertFontColor51;
            line-height: 1.4em;
            height: 2.5em;
            overflow: hidden;
            margin-bottom: 5px;
            font-weight: 500;
            text-overflow: -o-ellipsis-lastline;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .expert_con {
            color: @expertFontColor153;
            margin-bottom: 2px;
            display: table;
            -webkit-transform: scale(0.92);
            transform: scale(0.92);
            -webkit-transform-origin: 0;
            transform-origin: 0;
            line-height: 20px;
            .expert_con_text {
              max-width: 180px;
              height: 20px;
              overflow: hidden;
              display: table-cell;
              font-size: @indexFontSize12;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          .tips {
            margin-bottom: 5px;
            float: left;
            width: 100%;
            height: 22px;
            span {
              font-size: @indexFontSize12;
              height: 19px;
              padding: 0 4px;
              line-height: 19px;
              display: inline-block;
              box-sizing: border-box;
              color: rgba(169, 178, 244, 1);
              max-width: 83px;
              overflow: hidden;
              background: rgba(246, 247, 254, 1);
              border-radius: 2px;
              // padding-top: 1px;
              text-align: center;
            }
          }
        }
        .views {
          color: rgba(204, 204, 204, 1);
          display: table;
          -webkit-transform: scale(0.92);
          transform: scale(0.92);
          -webkit-transform-origin: 0;
          transform-origin: 0;
          max-width: 33%;
          position: absolute;
          bottom: 16px;
          left: 11px;
          .views_sign {
            display: table-cell;
            font-size: @indexFontSize12;
            background: url(../../../assets/images/home/signNum.png) no-repeat
              left center;
            background-size: 9px;
            padding-left: 11px;
          }
        }
      }
    }
  }
  .experts_online_swiper {
    .swiper-slide {
      width: 117px;
      height: 146px;
      background: @expertFontColor255;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.02);
      border-radius: 8px;
      border: 1px solid @expertBorderColor242;
      box-sizing: border-box;
      .imgCon {
        width: 46px;
        height: 46px;
        background: @expertBorderColor242;
        border-radius: 50%;
        margin: 0 auto;
        background: #eee;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        margin-top: 13px;
      }
      .con {
        padding: 0 13px;
        text-align: center;
        .tit {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin: 12px 0;
          font-size: @indexFontSize14;
          font-weight: 500;
          color: @expertFontColor51;
        }
        .info {
          max-height: 34px;
          line-height: 18px;
          font-size: @indexFontSize12;
          font-weight: 400;
          color: @expertFontColor153;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }
    .swiper-slide1 {
      background: @expertBorderColor242;
      position: relative;
      img {
        width: auto;
        height: 144px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  .course_special_banner1 {
    height: 116px;
    .swiper-wrapper {
      .swiper-slide {
        height: 116px;
        border-radius: 8px;
        background-size: cover;
        background-position: center center;
        background-color: @expertBorderColor242;
      }
    }
  }
  .course_special_banner2 {
    height: 116px;
    .swiper-wrapper {
      .swiper-slide {
        height: 116px;
        border-radius: 8px;
        background-size: cover;
        background-position: center center;
        background-color: @expertBorderColor242;
      }
    }
  }
  .course_special_banner3 {
    height: 116px;
    .swiper-wrapper {
      .swiper-slide {
        height: 116px;
        border-radius: 8px;
        background-size: cover;
        background-position: center center;
        background-color: @expertBorderColor242;
      }
    }
  }
  .special_list_swiper {
    padding-bottom: 14px;
    overflow: hidden;
    .swiper-wrapper {
      .swiper-slide {
        height: 135px;
        background: @expertFontColor255;
        box-sizing: border-box;
        padding-top: 10px;
        a {
          width: 100%;
          display: inline-block;
        }
        .imgCon {
          height: 82px;
          background-size: cover;
          background-position: center center;
          margin-bottom: 9px;
          position: relative;
          border-radius: 4px;
          .videoLoading {
            width: 59px;
            line-height: 1;
            background-color: #ff5353;
            position: absolute;
            color: rgba(255, 255, 255, 1);
            font-size: 10px;
            border-radius: 0 4px 0 4px;
            bottom: 0;
            text-align: center;
            padding: 3px 0;
          }
        }
        .tit {
          border: 0px !important;
          font-size: 13px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 18px;
          height: 36px;
          margin-bottom: 14px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .tit2 {
          color: rgba(255, 83, 83, 1);
        }
      }
    }
  }
  .canEatList-repice {
    padding-bottom: 20px;
    height: 120px;
    .swiper-wrapper {
      // overflow: hidden;
      .swiper-slide {
        height: 120px;
        border-radius: 8px;
        overflow: hidden;
        background-size: cover;
        background-position: center center;
        display: flex;
        position: relative;
        .swiper-slide-card {
          width: 100%;
          height: 100%;
          display: flex;
          .canEat-img {
            width: 92px;
            height: 92px;
            margin: 14px 8px;
            display: flex;
            justify-content: center;
            text-align: center;
            overflow: hidden;
            align-items: center;
            img {
              width: 92px;
              height: 92px;
            }
          }
          .canEat-recipe {
            width: 70px;
            height: 26px;
            background: #fd6e40;
            border-radius: 0px 8px 0px 8px;
            position: absolute;
            top: 0;
            right: 0;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 26px;
            text-align: center;
          }
          .canEat-cent {
            width: 220px;
            height: 92px;
            margin: 14px 8px;
            .canEat-title {
              width: 144px;
              height: 20px;
              font-size: 14px;
              font-family: PingFang-SC-Medium, PingFang-SC;
              font-weight: 500;
              color: #333333;
              line-height: 20px;
              max-width: 144px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .canEat-txt {
              margin-top: 18px;
              width: 144px;
              height: 20px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 18px;
            }
            .canEat-num {
              margin-top: 18px;
              width: 144px;
              height: 20px;
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #cccccc;
              line-height: 14px;
            }
          }
          .shop-cent {
            width: 220px;
            height: 92px;
            margin: 14px 8px;
            .shop-title {
              width: 211px;
              height: 20px;
              font-size: 14px;
              font-family: PingFang-SC-Medium, PingFang-SC;
              font-weight: 500;
              color: #333333;
              line-height: 20px;
              max-width: 211px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .shop-txt {
              margin-top: 18px;
              width: 100%;
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #fd6e40;
              line-height: 20px;
            }
            .shop-num {
              display: block;
              margin-top: 18px;
              width: 100%;
              height: 14px;
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #cccccc;
              line-height: 14px;
            }
          }
          .shop_a {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
    /deep/ .swiper-pagination-clickable {
      bottom: 30px;
      font-size: 0;
      position: absolute;
      text-align: center;
      transition: opacity 0.3s;
      transform: translateZ(0);
      z-index: 10;
      .swiper-pagination-bullet {
        width: 4px;
        height: 4px;
        background: #d8d8d8;
        opacity: 1;
        margin: 0 3px;
        &.swiper-pagination-bullet-active {
          width: 12px;
          height: 4px;
          background: #f1cd8f;
          border-radius: 2px;
        }
      }
    }
  }

  .banner_profile_swiper {
    height: 86px;
    padding-bottom: 20px;
    .swiper-wrapper {
      .swiper-slide {
        background-color: @expertBorderColor242;
        overflow: hidden;
        a {
          width: 100%;
          display: block;
        }
        span {
          width: 100%;
          height: 86px;
          display: block;
          background-size: 100% 100%;
          background-position: center center;
        }
      }
    }
    /deep/ .swiper-pagination-clickable {
      bottom: 8px;
      font-size: 0;
      position: absolute;
      text-align: center;
      transition: opacity 0.3s;
      transform: translateZ(0);
      z-index: 10;
      .swiper-pagination-bullet {
        width: 4px;
        height: 4px;
        background: @expertFontColor153;
        opacity: 1;
        margin: 0 2px;
        &.swiper-pagination-bullet-active {
          width: 12px;
          height: 4px;
          background: @mainColor;
          border-radius: 2px;
        }
      }
    }
  }
  .banner_point_swiper {
    height: 110px;
    padding-bottom: 20px;
    .swiper-wrapper {
      border-radius: 8px;
      .swiper-slide {
        background-color: @expertBorderColor242;
        overflow: hidden;
        border-radius: 8px;
        a {
          width: 100%;
          display: block;
        }
        span {
          width: 100%;
          height: 110px;
          display: block;
          background-size: 100% 100%;
          background-position: center center;
        }
      }
    }
    /deep/ .swiper-pagination-clickable {
      bottom: 8px;
      font-size: 0;
      position: absolute;
      text-align: center;
      transition: opacity 0.3s;
      transform: translateZ(0);
      z-index: 10;
      .swiper-pagination-bullet {
        width: 4px;
        height: 4px;
        background: @expertFontColor153;
        opacity: 1;
        margin: 0 2px;
        &.swiper-pagination-bullet-active {
          width: 12px;
          height: 4px;
          background: @mainColor;
          border-radius: 2px;
        }
      }
    }
  }
  .profile_card_swiper {
    margin: 0 17px;
  }
  .swiper-container {
    overflow: inherit;
  }
  .swiper-slide {
    overflow: hidden;
  }
  .baby_card_swiper {
    .swiper-slide {
      width: 96px !important;
      height: 140px;
      margin-right: 10px;
      border-radius: 8px;
      box-sizing: border-box;
      position: relative;
      .title {
        width: 100%;
        font-size: 12px;
        font-weight: 600;
        color: #333;
        margin-right: 96px;
        padding: 6px 0 10px 6px;
      }
      img {
        margin: 0 auto;
        display: block;
      }
      .text {
        text-align: center;
        padding-top: 12px;
        color: #d69f36;
      }
      .title_tips {
        position: absolute;
        top: 25px;
        left: 32px;
        width: 50px;
        background: #ff6f52;
        color: #fff;
        font-size: 8px;
        text-align: center;
        line-height: 16px;
        opacity: 0.71;
        border-radius: 7px;
        padding-top: 2px;
      }
    }
    .bblc {
      border: 1px solid rgba(255, 240, 240, 1);
      background: #fdf7f7;
      img {
        width: 32px;
        height: 62px;
      }
    }
    .czqx {
      border: 1px solid rgba(239, 243, 249, 1);
      background: #f9f9fe;
      .title {
        padding-bottom: 22px;
      }
      img {
        width: 50px;
        height: 50px;
      }
    }
    .eat {
      border: 1px solid rgba(239, 243, 249, 1);
      background: #f9f9fe;
      .title {
        padding-bottom: 22px;
      }
      img {
        width: 50px;
        height: 50px;
      }
    }
    .ymtx {
      border: 1px solid rgba(233, 245, 237, 1);
      background: #f4faf6;
      .title {
        padding-bottom: 22px;
      }
      img {
        width: 50px;
        height: 50px;
      }
    }
    .bbyy {
      border: 1px solid rgba(255, 242, 218, 1);
      background: #fffdef;
      .title {
        padding-bottom: 22px;
      }
      img {
        width: 51px;
        height: 51px;
      }
    }
    .mmyy {
      border: 1px solid rgba(255, 240, 240, 1);
      background: #fdf7f7;
      .title {
        padding-bottom: 22px;
      }
      img {
        width: 60px;
        height: 50px;
      }
    }
    .jtyy {
      border: 1px solid rgba(243, 248, 251, 1);
      background: #f9fdff;
      .title {
        padding-bottom: 22px;
      }
      img {
        width: 52px;
        height: 52px;
      }
    }
    .cjtx {
      border: 1px solid rgba(255, 234, 213, 1);
      background: #fff9f2;
      .title {
        padding-bottom: 22px;
      }
      img {
        width: 51px;
        height: 51px;
      }
    }
    .zdtx {
      border: 1px solid rgba(255, 243, 214, 1);
      background: #fffef2;
      .title {
        padding-bottom: 22px;
      }
      img {
        width: 50px;
        height: 50px;
      }
    }
    /deep/ .pagination {
      text-align: center;
    }
  }
  .baby_card_swiper1 {
    .minor {
      width: 31.33% !important;
    }
    .swiper-pagination-bullets {
      text-align: center;
    }
  }
  .child_list_swiper {
    .swiper-wrapper {
      margin-top: 4px;
      .swiper-slide {
        width: 340px;
        // margin-left: 12px;
        .img {
          width: 100%;
          height: 135px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          // position: absolute;
          // bottom: 41px;
          // width: 100%;
          // height: 60px;
          background: #fff;
          font-size: 14px;
          padding: 8px 12px;
          font-weight: 500;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
        }
      }
    }
  }
  .course_hot_swiper {
    .swiper-wrapper {
      margin: 0 10px;
      .swiper-slide {
        height: 116px;
        max-width: 160px;
        border-radius: 8px;
        overflow: hidden;
        .active_top {
          height: 36px;
          line-height: 36px;
          background: linear-gradient(
            270deg,
            rgba(255, 236, 174, 1) 0%,
            rgba(254, 236, 182, 1) 30%,
            rgba(255, 246, 219, 1) 74%,
            rgba(237, 211, 136, 1) 100%
          );
          p {
            font-weight: bold;
            font-size: @indexFontSize14;
            color: rgba(181, 132, 68, 1);
            text-align: center;
          }
        }
        img {
          width: 136px;
          height: 116px;
        }
        &:last-child {
          margin-right: 10px;
        }
      }
    }
  }
  .suckTopBanner__swiper {
    width: 100%;
    height: 34px;
  }
  .homeBg_banner_swiper {
    height: 100%;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    .swiper-slide {
      -webkit-overflow-scrolling: touch;
      img {
        width: 100%;
        // position: fixed;
      }
    }
    /deep/.pagination {
      position: absolute;
      top: 128px;
      left: 85%;
      z-index: 10;
      width: 38px;
      height: 22px;
      // border-radius: 13px;
      // border: 1px solid #ffffff;
      // background: rgba(255, 255, 255, 0.6);
      text-align: center;
      line-height: 22px;
      .swiper-pagination-bullet {
        background: #c1c1c1;
      }
      .swiper-pagination-bullet-active {
        background: #f4c757;
      }
    }
  }
  // 孕育百科-编辑推荐
  .exclusive_edit_swiper {
    .swiper-wrapper {
      .swiper-slide {
        width: 128px;
        img {
          width: 128px;
          height: 78px;
          display: block;
          border-radius: 8px;
        }
        .text {
          width: 120px;
          padding: 8px 4px 12px;
          font-size: 13px;
          font-weight: bold;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
  // 首页专家视角-资源位
  .expert_article_swiper {
    .article_list {
      width: 270px !important;
      padding: 13px 8px;
      background: #edf1f8;
      border-radius: 8px;
      border: 1px solid #ececec;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      .left {
        width: 135px;
        height: 72px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          border-top-right-radius: 4px;
          border-top-left-radius: 4px;
          display: block;
        }
        i {
          width: 20px;
          height: 20px;
          display: inline-block;
          background: url('../../../assets/images/nweHome/play.png') no-repeat;
          background-size: contain;
          position: absolute;
          left: 57px;
          top: 26px;
          z-index: 1;
        }
        span {
          width: 100%;
          display: inline-block;
          line-height: 18px;
          font-size: 10px;
          text-align: center;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          background: linear-gradient(90deg, #fef5a0 0%, #fee063 100%);
          color: #7b4215;
        }
      }
      .right {
        width: 141px;
        margin-left: 8px;
        .title {
          width: 100%;
          height: 44px;
          line-height: 22px;
          font-size: 15px;
          color: #333;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          -ms-text-overflow: ellipsis;
          text-overflow: ellipsis;
        }
        .name {
          font-size: 11px;
          color: #999;
          width: 100%;
          line-height: 16px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .share_info {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          img {
            width: 27px;
            height: 27px;
          }
          button {
            width: 62px;
            height: 28px;
            border: none;
            background: linear-gradient(90deg, #ff9062 0%, #ff8e6b 100%);
            border-radius: 27px;
            color: #fff;
            margin-left: 8px;
          }
          .success {
            background: linear-gradient(90deg, #ff9062 0%, #ff8e6b 100%);
            opacity: 0.59;
          }
        }
      }
    }
    // 营养厨房
    .nutrition_kitchen {
      padding: 13px 8px;
      .left {
        width: 133px;
        height: 90px;
        img {
          height: 72px;
        }
      }
      .right {
        width: 143px;
        position: relative;
        .share_info {
          img {
            position: absolute;
            right: 0;
            bottom: 0;
          }
        }
      }
    }
    // 新鲜育儿观   哈佛育儿课堂
    .fresh_parenting,
    .harvard_classroom {
      padding: 20px 8px 17px;
      .left {
        width: 109px;
        height: 79px;
        img {
          height: 61px;
        }
      }
      .right {
        width: 167px;
      }
    }
    // 星妈课堂
    .xingma_classroom {
      .left {
        height: 92px;
        width: 67px;
        img {
          border-radius: 4px;
        }
        span {
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
      .right {
        width: 209px;
        .time {
          margin-top: 6px;
          font-size: 11px;
          line-height: 16px;
          color: #999;
        }
        .share_info {
          justify-content: space-between;
          .order_number {
            margin-top: 3px;
            line-height: 16ppx;
            color: #999;
            font-size: 11px;
          }
          .share {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
  // 首页好物推荐
  .goods_recommend_swiper {
    .goods_box {
      .box {
        width: 120px;
        height: 191px;
        margin-right: 8px;
        position: relative;
        border-radius: 8px;
        border: 1px solid #ececec;
        .goods_img {
          width: 108px;
          height: 108px;
          padding: 11px 6px;
          i {
            display: block;
            width: 108px;
            height: 108px;
            background-size: 100% 100%;
            background-position: center center;
          }
        }
        .title {
          width: 112px;
          padding: 4px 4px 0;
          line-height: 20px;
          color: #333;
          font-size: 14px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .price {
          margin-top: 8px;
          padding: 0 4px;
          color: #ff6146;
          font-weight: bold;
          font-size: 12px;
          line-height: 17px;
        }
      }
      &:last-child {
        .box {
          margin-right: 12px;
        }
      }
      .tagWrap {
        width: 100%;
        height: 198px;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
  // 热门活动
  .popular_activities_swiper {
    position: relative;
    overflow: hidden;
    .swiper-wrapper {
      .swiper-slide {
        width: 100%;
        height: 220px;
        img {
          width: 100%;
          height: 220px;
        }
      }
    }
    /deep/ .swiper-pagination-clickable {
      position: absolute;
      bottom: 38px;
      left: 50%;
      transform: translate(-50%, 0);
      width: auto;
      transition: opacity 0.3s;
      z-index: 10;
      .swiper-pagination-bullet {
        width: 4px;
        height: 4px;
        background: @expertFontColor153;
        opacity: 1;
        margin: 0 2px;
        &.swiper-pagination-bullet-active {
          width: 12px;
          height: 4px;
          background: @mainColor;
          border-radius: 2px;
        }
      }
    }
  }
}
// .mySwiper .banner_recommend_swiper{
//   padding-bottom: 0.33333rem!important;
// }
// .mySwiper .banner_recommend_swiper .swiper-pagination-clickable{
//   bottom:0!important;
// }
</style>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
import harvardData from '../../../utils/mockData/harvardData'
import API from '@/utils/axiosApi/getUserInfoIntellect' //智能推算接口
export default {
  name: 'mySwiper',
  data() {
    return {
      clientX1: 0,
      activeBabyCardIndex: 0,
      timer: 0,
    }
  },

  props: {
    swipeid: {
      type: String,
      default: '',
    },
    paginationFlag: {
      type: Boolean,
      default: false,
    },
    slidesNum: {
      type: Number,
      default: 3,
    },
    spaceBetweenNum: {
      type: Number,
      default: 0,
    },
    autoplayNumber: {
      type: Number,
      default: 3000,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    centeredSlides: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      default: '',
    },
    // touchEndFn: {
    //   type: Function,
    //   default: null
    // },
    type: {
      type: String,
      default: null,
    },
    offsetPxAfter: {
      type: Number,
      default: 0,
    },
    offsetPxBefore: {
      type: Number,
      default: 0,
    },
    direction: {
      type: String,
      default: 'horizontal',
    },
    allowTouchMove: {
      type: Boolean,
      default: true,
    },
    cssWidthAndHeight: {
      type: Boolean,
      default: false,
    },
    referrerItemId: {
      type: Number,
      default: 0,
    },
    recommendList: {
      type: Array,
    },
    readingTime: {
      type: Number,
      default: 0,
    },
  },
  activated() {
    console.log(this.dom, '------------===================')
  },
  mounted() {
    this.isKeep = true
    this.init()
  },
  methods: {
    init() {
      var that = this
      this.dom = new Swiper('.' + that.swipeid, {
        //分页器
        pagination: { el: '.pagination', clickable: true },
        loop: that.loop,
        // 切换方向
        direction: that.direction,
        // 显示个数
        slidesPerView: that.slidesNum == 0 ? 'auto' : that.slidesNum,
        // slide间距
        spaceBetween: that.spaceBetweenNum,
        //用户操作swiper之后，不禁止autoplay
        //autoplayDisableOnInteraction: false,
        //修改swiper自己或子元素时，自动初始化swiper
        observer: true,
        //修改swiper的父元素时，自动初始化swiper
        observeParents: true,
        allowTouchMove: this.allowTouchMove,
        cssWidthAndHeight: this.cssWidthAndHeight,
        // 轮播时间间隔
        autoplay: that.autoplay
          ? {
              delay: that.autoplayNumber,
              stopOnLastSlide: false,
              disableOnInteraction: false,
            }
          : that.autoplay,
        // 居中显示
        centeredSlides: that.centeredSlides,
        offsetPxAfter: that.offsetPxAfter,
        offsetPxBefore: that.offsetPxBefore,
        on: {
          tap: function (e) {
            console.log(12312)
            // 营养厨房轮播图跳转添加自定义属性 loop模式：会在原本slide 前后复制若干个slide (默认一个，不会复制点击事件)，解决办法就是定义自定义属性，点击拿到自定义属性id，子传父跳转
            if (e.target.attributes['data-item']) {
              const data = JSON.parse(e.target.attributes['data-item'].nodeValue)
              // console.log(JSON.parse(e.target.attributes['data-item'].nodeValue), 'nodeValue')
              that.$emit(
                'slideClick',
                  data.recipe_id || data.id
              )
            }
            console.log(e.target)
            // 首页资源位跳转
            if (e.target.attributes['home-data-item']) {
              that.$emit(
                'slideClick',
                JSON.parse(e.target.attributes['home-data-item'].nodeValue)
              )
            }else{
              try{
                const data = JSON.parse(e.target.attributes['data'].nodeValue)
                that.$emit(
                    'slideClick',
                    data.id
                )
              }catch (event){
                console.log(e)
                // console.log(e.target.attributes['data'].nodeValue)
              }

            }
          },
          // touchEnd: function (swiper, event) {
          //   if (that.swipeid === 'detail_recommend_swiper') {
          //     //添加智能推荐（周需）
          //     const arr = harvardData.expertList
          //     this.activeIndex = this.activeIndex % arr.length
          //     console.warn(
          //       this.activeIndex,
          //       event,
          //       swiper,
          //       '2937294y3887343874384738473847384'
          //     )
          //   }
          // },
          slideChangeTransitionEnd: function () {
            if (that.swipeid === 'detail_recommend_swiper') {
              const arr = harvardData.expertList
              this.activeIndex = this.activeIndex % arr.length
              const itemData = that.recommendList.filter((item, index) => {
                return index === this.activeIndex
              })
              const pkData = {
                itemId: `${itemData[0].pkContent}`,
                itemTraceId: itemData[0].itemTraceId,
                itemType: itemData[0].itemType,
              }
              const vote = {
                crmId: that.userId,
                behaviorType: 1,
                itemData: [pkData],
                referrerItemId: `${that.referrerItemId}`,
                // commentText//非必填
                duration: that.readingTime,
              }
              console.warn('智能推荐需要的参数', vote)
              API.reportUserBehavior({}, vote, (res) => {
                if (res.code == 200) {
                  console.log(res, '用户滑动智能推算成功')
                } else {
                  console.error('请求失败')
                }
              })
            } else if (that.swipeid === 'expert_recommend_swiper') {
              const arr = harvardData.expertList
              this.activeIndex = this.activeIndex % arr.length
              sensors.track('ExchangSpecialist', {
                specialist_name: arr[this.activeIndex].name,
              })
            }
            // this.activeIndex = this.activeIndex % arr.length
            that.$emit('slideChange', this.activeIndex)
          },
          touchStart: function (event) {
            //if(that.swipeid==='archives_card_swiper'){
            // that.clientX1 = event.changedTouches[0].clientX
            // that.timeStampX1 = event.timeStamp
            // console.log('开始坐标',that.clientX1);
            // }
          },
          touchMove: function (event) {
            //你的事件
            //   if(that.swipeid==='archives_card_swiper'){
            //     if (that.clientX1 === 0) return false
            //     // console.log('走');
            //     const clientX2 = event.changedTouches[0].clientX
            //     let disX = that.clientX1 - clientX2
            //     // 判断左右滑动的阀值为15
            //     if (disX > 15) {
            //       // 左滑
            //       that.clientX1 = 0
            //       that.activeBabyCardIndex=1
            //       // this.currentSwiper = this.currentSwiper + 1
            //     }
            //     if (disX < -15) {
            //       // 右滑
            //       that.clientX1 = 0
            //       that.activeBabyCardIndex=0
            //       // this.currentSwiper = this.currentSwiper - 1
            //     }
            //   }
          },
          transitionEnd: function () {
            if (that.swipeid === 'archives_card_swiper') {
              var index = that.dom.progress
              if (index == '1') {
                that.activeBabyCardIndex = 1
              } else {
                that.activeBabyCardIndex = 0
              }
              //   console.log(index)
              //   console.log(that.activeBabyCardIndex)
              // var timeStampX2 = event.timeStamp
              // var diffX2 = timeStampX2 - that.timeStampX1
              // if (diffX2>500) {
              //   return false
              // }
              console.log(this.activeIndex)
              that.$emit('pageChange', that.activeBabyCardIndex)
            }
          },
        },
      })
      setTimeout(() => {
        $('.baby_card_swiper1 .swiper-wrapper').css(
          'transform',
          'translate3d(0px, 0px, 0px)'
        )
      }, 1000)
    },
    jumpSwiper(id) {
      this.dom.slideTo(id)
    },
  },
}
</script>
